export default __webpack_public_path__ + "static/media/02_red_segment_800.b0f057c7.gif";